import React from 'react';
import { removeHost } from "../../utils/functions";
import { v4 as uuid } from 'uuid';
import { Link } from 'gatsby';
import Button from '../button/Button';
import Img from "gatsby-image"


// import Breadcrumbs from '../breadcrumbs/Breadcrumbs'
const SubCategories = ({ categories }) => {
  return (
    categories && (
      <div className="subCategories">
        <div className="subCategories__wrapper">
          {categories.nodes.map(subCat => (
            <div key={uuid()} className="subCategories__item">
              <h2 className="subCategories__item__heading heading--normal">
                <Link to={removeHost(subCat.uri)} >
                  {subCat.name}
                </Link>
              </h2>
              <div className="subCategories__item__wrapper">
                <div className="subCategories__item__content">
                  <div className="content" dangerouslySetInnerHTML={{ __html: subCat.acfProductCategory.parentDescription }}>
                  </div>
                  <div className="subCategories__item__button">
                    <Button url={subCat.uri} title={subCat.acfProductCategory.buttonText} />
                  </div>
                </div>
                <div className="subCategories__item__img">
                  <Link to={removeHost(subCat.uri)} >
                    <Img fluid={subCat.acfProductCategory.parentImg.imageFile.childImageSharp.fluid} />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  )
}
export default SubCategories
